module.exports = __webpack_public_path__ + "media/components/dropdown-search-combo/static/icon-search-white-734ce8bce79806ccd51d51d775c40fb5.svg";